module.exports = __webpack_public_path__ + "img/ios-share-icon.ebb4eae4.svg";